import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSystem } from '../../../hooks/useSystem';
import { observer } from 'mobx-react';
import { GetPacksRequest } from '@foxbun/lib-goferal-types';
import { SearchInputWidget } from '../../../widgets/forms/SearchInputWidget';
import { EmptyWidget } from '../../../widgets/content/EmptyWidget';
import { AnimatePageWidget } from '../../../widgets/layout/AnimatePageWidget';
import { PackModel } from '../../../core/models/PackModel';
import * as _ from 'lodash';
import { MediaIconWidget } from '../../../widgets/content/MediaIconWidget';
import { AppLink } from '../../../widgets/utils';
import { IconGridLayoutWidget } from '../../../widgets/collection/IconGridLayoutWidget';
import { useBufferedSearch } from '../../../hooks/useBufferedSearch';

export const PacksPage: React.FC = observer((props) => {
  const system = useSystem();

  const normalizeReq = (req) => {
    return _.pickBy(req, (value) => value != null);
  };

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState<string>(null);
  const [packs, setPacks] = useState<PackModel[]>([]);
  const [req, setReq] = useState<GetPacksRequest>({});

  const loadPacks = useCallback(() => {
    setLoading(true);
    system.pack_store
      .getPacks(req)
      .then((packs) => {
        setPacks(packs);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [JSON.stringify(req)]);

  useEffect(() => {
    loadPacks();
  }, [JSON.stringify(req)]);

  useBufferedSearch({
    search,
    cb: (search) => {
      setReq(normalizeReq({ search }));
    }
  });

  return (
    <AnimatePageWidget slide={false}>
      <S.Packs>
        <S.Controls>
          <S.Input
            value={search}
            placeholder="search pack names"
            loading={loading}
            onChange={(search) => {
              setSearch(search);
            }}
          />
        </S.Controls>
        {!loading && packs.length === 0 ? <EmptyWidget label="No packs found" /> : null}
        {packs.length > 0 ? (
          <IconGridLayoutWidget<PackModel>
            gap={10}
            cols={3}
            elements={packs}
            generateElement={(pack) => {
              return (
                <S.LinkWrapper key={pack.key} to={pack.link} push={true}>
                  <S.Media
                    font_size={40}
                    media={{
                      name: pack.data.name,
                      image: pack.image
                    }}
                  />
                </S.LinkWrapper>
              );
            }}
          />
        ) : null}
      </S.Packs>
    </AnimatePageWidget>
  );
});

namespace S {
  export const Input = styled(SearchInputWidget)``;

  export const Controls = styled.div`
    display: flex;
    flex-direction: column;
  `;

  export const Packs = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  `;

  export const Media = styled(MediaIconWidget)`
    border-radius: 4px;
  `;

  export const LinkWrapper = styled(AppLink)`
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    height: 100%;
  `;
}
